import React from 'react';
import {  DateInput,Responsive,SimpleList,NumberField,DateField,Show,ShowButton,List, TextField, SimpleShowLayout,ReferenceInput,Filter,SelectInput,FunctionField } from 'admin-on-rest/lib/mui';

import Datagrid from './Datagrid';

const HafkadotMonthFilter = (props) => (
    <Filter {...props}>
       
         <ReferenceInput label="בית עסק" source="id" reference="customers" allowEmpty>
            <SelectInput optionText="name_heb" />
        </ReferenceInput>

    </Filter>
);

const rowStyle = (record) => {
    if (record.commission_ammount <0) return { backgroundColor: '#fdd' };
    
    return {};
};

export const HafkadotMonthList = (props) => (
    <List title="דף חשבון" perPage={30} {...props}  filters={<HafkadotMonthFilter /> }>
      <Responsive
       small={
                <SimpleList
                    primaryText={record =>"תאריך הפקדה"+ new Date(record.deposit_date.date).toLocaleDateString()}
                    secondaryText={record =>"סוג עסקה"+ record.tnuaa_type}
                    tertiaryText={record =>"מספר ריכוז"+ record.rikuz_number}
                   
                    
                />
            }
 medium={

          <Datagrid  rowStyle={rowStyle} bodyOptions={{showRowHover: true }}>
            
<TextField label="#" source="id" />

<DateField label="תאריך הפקדה" source="deposit_date.date" locales="he-IL"/>
<DateField label="תאריך עסקה" source="rchisha_date.date" locales="he-IL"/>
<DateField label="תאריך זיכוי" source="zikui_date.date" locales="he-IL" />
<TextField label="סוג עסקה" source="tnuaa_type" />


<NumberField label="סכום עסקה" source="schum_iska" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום ברוטו לזיכוי" locales="he-IL" source="zikui_total_bruto" options={{ style: 'currency', currency: 'ILS' }}/>

<NumberField label="עמלה" style={{overflow:'visible '}} source="commission_ammount" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>
<NumberField label="עמלה + מעמ"  style={{overflow:'visible '}} source="commission_ammount_vat" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }} />
<NumberField label="סכום נטו לזיכוי" style={{overflow:'visible '}} source="neto_zicui" locales="he-IL" options={{ style: 'currency', currency: 'ILS' }}/>

<TextField label="מספר ריכוז" source="rikuz_number" />
<TextField label="כ.א 4 ספרות" source="cc_id" />

    

    
            <ShowButton />
        </Datagrid>
 }
         />
    </List>
);


const HafkadotMonthTitle = ({ record }) => {
    return <span>מספר {record ? `"${record.id}"` : ''}</span>;
};













const HafkadotMonthStyle = {
  width:120,
    minHeight: 40,
    marginLeft: '2em',
    display: 'inline-block',
    verticalAlign: 'top'
};



export const HafkadotMonthShow = (props) => (

<Show title={<HafkadotMonthTitle />} {...props}>
 <SimpleShowLayout >
  <TextField style={HafkadotMonthStyle}  label="#" source="id" />
<TextField style={HafkadotMonthStyle}  label="מזהה רשת חיצוני" source="external_id" />

<TextField style={HafkadotMonthStyle} label="מספר בית עסק" source="buisiness_id" />
<TextField style={HafkadotMonthStyle} label="מספר כרטיס מלא" source="cc_id" />

<TextField style={HafkadotMonthStyle}  elStyle={{ width: '5em' }} label="מספר שובר" source="shovar_number" />
<TextField style={HafkadotMonthStyle} label="סוג תנועה" source="tnuaa_type" />
<TextField style={HafkadotMonthStyle} label="מקור  תנועה" source="tnuaa_source" />
<DateField style={HafkadotMonthStyle} label="תאריך הפקדה" source="deposit_date.date" />
<DateField style={HafkadotMonthStyle} label="תאריך זיכוי" source="zikui_date.date" />
<TextField style={HafkadotMonthStyle} label="מספר חשבון" source="account_number" />
<TextField style={HafkadotMonthStyle} label="מטבע תנועה" source="tnuaa_currency" />
<TextField style={HafkadotMonthStyle} label="מטבע זיכוי" source="zikui_currency" />
<TextField style={HafkadotMonthStyle} label="אינדיקציה לתשלומים" source="payments_indication" />
<TextField style={HafkadotMonthStyle} label="סכום עסקה  ברוטו תשלומים" source="bruto_iska_tashlumim" />
<TextField style={HafkadotMonthStyle} label="סכום ברוטו לזיכוי " source="zikui_total_bruto" />
<TextField style={HafkadotMonthStyle} label="סכום עמלה" source="commission_ammount" />
<TextField style={HafkadotMonthStyle} label="מעמ עמלה" source="comission_vat" />
<TextField style={HafkadotMonthStyle} label="סכום ההנחה" source="discount_ammount" />
<TextField style={HafkadotMonthStyle} label="סכום זיכוי" source="total_zikui" />
<TextField style={HafkadotMonthStyle} label="מספר תשלום נוכחי" source="current_payment_number" />
<TextField style={HafkadotMonthStyle} label="מספר תשלומים" source="total_payments" />
<TextField style={HafkadotMonthStyle} label="יתרת תשלומים" source="remaining_payments" />
<TextField style={HafkadotMonthStyle} label="סכום ריבית דמי ניכיון" source="total_dme_nikayon_interest" />
<TextField style={HafkadotMonthStyle} label="סכום דמי ניהול " source="total_dme_nihul" />
<TextField style={HafkadotMonthStyle} label="ניקוד ב- pos" source="pos_points" />

<TextField style={HafkadotMonthStyle} label="מספר מסוף" source="masof_number" />
<TextField style={HafkadotMonthStyle} label="תש' ראשון" source="first_payment" />
<TextField style={HafkadotMonthStyle} label="סכום תשלום" source="total_ammount" />
<TextField style={HafkadotMonthStyle} label="מועדון" source="club" />

<TextField style={HafkadotMonthStyle} label="קוד אישור" source="kod_ishur" />
<TextField style={HafkadotMonthStyle} label="קוד מאפיין  עסקה" source="kod_meafyen_iska" />
<TextField style={HafkadotMonthStyle} label="קוד אופי עסקה" source="kod_ofi_iska" />
<TextField style={HafkadotMonthStyle} label="מזהה חד ערכי" source="unique_id" />
<TextField style={HafkadotMonthStyle} label="סכום ביטול" source="bitul_ammount" />
<TextField style={HafkadotMonthStyle} label="סכום עצירה" source="stop_ammount" />
<TextField style={HafkadotMonthStyle} label="מזהה תנועה" source="tnuaa_id" />
<TextField style={HafkadotMonthStyle} label="מהות עסקה" source="mahut_iska" />
<TextField style={HafkadotMonthStyle} label="שער המרה" source="shaar_hamara" />
<TextField style={HafkadotMonthStyle} label="שדה Z" source="z_field" />
<TextField style={HafkadotMonthStyle} label="מזדמנת כ/ל" source="mizdamenet" />
<TextField style={HafkadotMonthStyle} label="סטטוס רשומה 1/2" source="status_reshuma" />
<TextField style={HafkadotMonthStyle} label="שם בית עסק" source="shem_esek" />
<TextField style={HafkadotMonthStyle} label="מספר חשבון" source="mispar_cheshbon" />
<TextField style={HafkadotMonthStyle} label="מזהה תוכנית כאל לקבל יותר" source="mezahe_tochnit_cal_yoter" />
<TextField style={HafkadotMonthStyle} label="סכום הנחת כאל לקבל יותר" source="hanacha_cal_yoter" />
<TextField style={HafkadotMonthStyle} label="אחוז הנחת כאל לקבל יותר" source="ahuz_hanacha_cal_yoter" />
<TextField style={HafkadotMonthStyle} label="Mid Trn ID" source="mid_trn_id" />
<TextField style={HafkadotMonthStyle} label="PSP Trn ID" source="psp_trn_id" />
<TextField style={HafkadotMonthStyle} label="Gateway Trn ID" source="gateway_trn_id" />
<TextField style={HafkadotMonthStyle} label="מזהה בקשת אישור" source="mezahe_bakasha_ishur" />

<TextField style={HafkadotMonthStyle} label="מספר חשבונית" source="mispar_cheshbonit" />
<TextField style={HafkadotMonthStyle} label="מספר משלם" source="mispar_meshalem" />
<TextField style={HafkadotMonthStyle} label="סוג תנועה שבא" source="sug_tnuaa_shva" />
<TextField style={HafkadotMonthStyle} label="סכום מזומן CASHBACK" source="mezuman_schum_cashback" />
<TextField style={HafkadotMonthStyle} label="מזהה עסקה שבא" source="mezahe_iska_shva" />
<TextField style={HafkadotMonthStyle} label="אינדיקציה לתייר" source="tayar_indikazia" />
<TextField style={HafkadotMonthStyle} label="קובץ מקור" source="source_file" />

         </SimpleShowLayout>
    </Show>
);





// WEBPACK FOOTER //
// ./src/components/Hafkadot/hafkadot_month.js